import { createFileRoute } from "@tanstack/react-router";

import { VoicePage } from "../../features/voice/VoicePage";

export const Route = createFileRoute("/_app/voice")({
  component: VoicePage,
});
